import React from "react";

const Checkbox = ({ label, checked, onChange, name, helper }) => {
  return (
    <div className="flex flex-col gap-2">
      <label className="inline-flex w-fit items-center gap-2 text-sm text-slate-600 dark:text-slate-400">
        <input
          type="checkbox"
          name={name}
          checked={checked}
          onChange={onChange}
          className="h-4 w-4 rounded border-slate-300 dark:border-slate-600 text-[#4f46e5] focus:ring-[#4f46e5] dark:bg-slate-700"
        />
        {label}
      </label>
      {helper && (
        <span className="text-xs text-slate-500 dark:text-slate-400">
          {helper}
        </span>
      )}
    </div>
  );
};

export default Checkbox;
